var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreviewPublish = function SvgPreviewPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.992 2.008 2.499 5.802l3.495 2.023 3.083-3.083a.834.834 0 0 1 1.178 1.18L7.172 9.004l2.025 3.494zm.269-1.87c.996-.361 1.96.604 1.6 1.6l-4.402 12.17c-.361.999-1.725 1.12-2.257.202L5.52 9.478.889 6.797C-.03 6.265.092 4.901 1.09 4.54z",
    clipRule: "evenodd"
  })));
};
export default SvgPreviewPublish;